import { useState, useRef, ReactChild, useCallback } from 'react';

import styles from './AccordionWithButton.module.scss';

interface IAccordionWithButtonProps {
  content: string | ReactChild | ReactChild[];
}

export const AccordionWithButton = ({ content }: IAccordionWithButtonProps) => {
  const [isActive, setIsActiveState] = useState(false);
  const [setHeight, setHeightState] = useState('0px');
  const contentRef = useRef<HTMLDivElement>(null);

  const toggleAccordion = useCallback(() => {
    setIsActiveState(!isActive);
    let height = '0px';

    if (!isActive && contentRef && contentRef.current) {
      const current = contentRef.current || {
        scrollHeight: 0,
      };

      height = `${current.scrollHeight}px`;
    }
    setHeightState(height);
  }, [isActive]);

  return (
    <div>
      {typeof content === 'string' ? (
        <>
          <button className={styles.ShowMore} type="button" onClick={toggleAccordion}>
            Показать полностью
          </button>

          <div
            className={styles.AccordionContent}
            ref={contentRef}
            style={{ maxHeight: `${setHeight}` }}
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: content }}
          />
        </>
      ) : (
        <>
          <div className={styles.AccordionContent} ref={contentRef} style={{ maxHeight: `${setHeight}` }}>
            {content}
          </div>
          <button className={styles.ShowMore} type="button" onClick={toggleAccordion}>
            {!isActive ? 'Показать полностью' : 'Скрыть'}
          </button>
        </>
      )}
    </div>
  );
};
